export const alarmsPluralMapping = {
  '=0': '0 alarms',
  '=1': '1 alarms',
  other: '# alarms',
};
